export function installLegacyWebViewGlobals(scope) {
  if (!scope || typeof scope !== 'object') return;

  const ObjectConstructor = scope.Object || Object;
  const PromiseConstructor = scope.Promise || Promise;

  if (typeof scope.globalThis === 'undefined') {
    Object.defineProperty(scope, 'globalThis', {
      configurable: true,
      enumerable: false,
      value: scope,
      writable: true,
    });
  }

  if (typeof scope.queueMicrotask !== 'function') {
    scope.queueMicrotask = (callback) => Promise.resolve().then(callback);
  }

  if (typeof ObjectConstructor.fromEntries !== 'function') {
    Object.defineProperty(ObjectConstructor, 'fromEntries', {
      configurable: true,
      enumerable: false,
      value(entries) {
        if (entries == null || typeof entries[Symbol.iterator] !== 'function') {
          throw new TypeError('Object.fromEntries requires an iterable');
        }

        const result = {};
        for (const entry of entries) {
          if (
            entry == null
            || (typeof entry !== 'object' && typeof entry !== 'function')
          ) {
            throw new TypeError('Object.fromEntries iterable values must be entry objects');
          }

          Object.defineProperty(result, entry[0], {
            configurable: true,
            enumerable: true,
            value: entry[1],
            writable: true,
          });
        }

        return result;
      },
      writable: true,
    });
  }

  if (typeof PromiseConstructor.allSettled !== 'function') {
    Object.defineProperty(PromiseConstructor, 'allSettled', {
      configurable: true,
      enumerable: false,
      value(iterable) {
        const wrapped = Array.from(iterable, (value) => (
          PromiseConstructor.resolve(value).then(
            (fulfilledValue) => ({ status: 'fulfilled', value: fulfilledValue }),
            (reason) => ({ status: 'rejected', reason }),
          )
        ));

        return PromiseConstructor.all(wrapped);
      },
      writable: true,
    });
  }
}
